import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const CheckIcon = React.forwardRef<SVGSVGElement, IconProps>(function CheckIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" d="M8.8 15.88 4.62 11.7l-1.41 1.42L8.8 18.7l12-12-1.41-1.42z"/>
        </IconBase>
    );
});
